module.exports = __webpack_public_path__ + "img/container-monitor-bg.f8e31047.png";